import { AppIcon } from '@/components/ui/app-icon';
import { GongIcon } from '@/components/ui/icons/meeting-notes-icons';
import {
  GoogleDocsIcon,
  GoogleSheetsIcon,
} from '@/components/ui/icons/google-product-icons';
import { CopilotIcon } from '@/components/ui/copilot-icon.component';
import { CONNECTORS as BRAND_MARKS } from '@/containers/onboarding/connector-logos';
import { iconEnvelope } from '@/lib/icons';
import { cn } from '@/lib/utils';
import type { NodeLogo } from './connectors';

/** A connector's own mark: the tool's logo, Cleanlist's icon in each theme,
 *  Clu's for the Agents step, an envelope for Email. Decorative; the name
 *  always sits beside it. */
export function ConnectorLogo({
  id,
  className,
}: {
  id: NodeLogo;
  className?: string;
}) {
  const size = cn('size-4 shrink-0 object-contain', className);
  switch (id) {
    case 'cleanlist':
      return (
        <>
          <img
            src='/cleanlist-icon-black.svg'
            alt=''
            aria-hidden='true'
            className={cn(size, 'dark:hidden')}
          />
          <img
            src='/cleanlist-icon-white.svg'
            alt=''
            aria-hidden='true'
            className={cn(size, 'hidden dark:block')}
          />
        </>
      );
    case 'outreach':
    case 'salesloft':
    case 'nooks':
    case 'instantly':
    case 'attio':
      return (
        <img
          src={
            id === 'outreach'
              ? '/logos/outreach.png'
              : id === 'nooks'
                ? '/logos/nooks.webp'
                : `/logos/${id}.svg`
          }
          alt=''
          aria-hidden='true'
          className={size}
        />
      );
    case 'email':
      return (
        <AppIcon
          icon={iconEnvelope}
          aria-hidden
          className={cn(size, 'text-muted-foreground')}
        />
      );
    case 'google_sheets':
      return <GoogleSheetsIcon className={size} />;
    case 'google_docs':
      return <GoogleDocsIcon className={size} />;
    case 'gong':
      return <GongIcon className={size} />;
    case 'clu':
      return <CopilotIcon className={size} />;
    default: {
      const { Mark } = BRAND_MARKS[id];
      return <Mark className={size} />;
    }
  }
}
